export const BASIC_FIELDS = [
  { name: 'title', label: 'Title', type: 'input', hasLocalization: true },
  { name: 'name', label: 'Name', type: 'input', hasLocalization: true },
  { name: 'type', label: 'Type', type: 'input' }
  // { name: 'descriptions', label: 'Description', type: 'textarea', rows: 3, hasLocalization: true }
];

export const PRODUCT_SPECIFIC_FIELDS = [
  {
    name: 'typeProduct',
    label: 'Product Type - Bonds or Funds',
    type: 'input',
    hasLocalization: true
  },
  { name: 'interestRate', label: 'Interest rate', type: 'input', hasLocalization: true },
  { name: 'isin', label: 'ISIN number', type: 'input' },
  { name: 'term', label: 'Term', type: 'input', hasLocalization: true },
  { name: 'interestPaid', label: 'Interest paid', type: 'input', hasLocalization: true },
  { name: 'redemption', label: 'Redemption', type: 'input', hasLocalization: true },
  { name: 'offerPeriodUntil', label: 'Offer period', type: 'date' },
  { name: 'minimalAmount', label: 'Minimal amount', type: 'number', min: 0, step: 1 },
  {
    name: 'offerAndConditions',
    label: 'Offer and conditions',
    type: 'input',
    hasLocalization: true
  },
  { name: 'company', label: 'Company', type: 'input', hasLocalization: true },
  { name: 'linkToCentralBankOfLatvia', label: 'Link to Central bank of Latvia', type: 'input' }
];

export const CHECKBOX_FIELDS = [
  { name: 'processingFee', label: 'Processing fee' },
  { name: 'stockDeposit', label: 'Stock deposit' },
  {
    name: 'isRequired',
    label: 'Is required (appears in profile after registration)',
    showAlways: true
  }
];
